import Axios from 'axios';
import { baseUrl } from '../config/serviceConfig';

const Get = (path, token) => {
    return Axios({
        method: 'GET',
        url: baseUrl + path,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        }
    })
}

export default Get;